import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getDelegationList } from 'Delegation/Domain/Services/GetDelegationListService';
import { Box, IconButton, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { PRIVATE_USER_GESTION_DE_SERVICIOS, PRIVATE_USER_LIST_DELEGATION_SERVICE } from 'DelegationService/DelegationService/Application/Constants/PathsConstants';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import Loader from 'UI/Application/Components/Loaders/Loader';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';




function TableDelegationView() {
    const { t } = useTranslation();
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [delegacion, setDelegacion] = React.useState([]);
    const [loadDelegation, setLoadDelegation] = React.useState(true);
    const [lastPage, setLastPage] = React.useState(1);
    const navigate = useNavigate();
    const limit = 10;
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
        setOffset((newPage - 1) * limit);
        setLoadDelegation(true);
    };
    React.useEffect(() => {
        if (loadDelegation) {
            getDelegationList({
                offset: offset,
                limit: limit,
            }).then((response) => {
                if (!response || !response.records) {
                    setDelegacion([]);
                    return;
                }
                setDelegacion(response.records);
                setLastPage(Math.ceil(response.total / limit));
                setLoadDelegation(false);
            });
        }
    }, [loadDelegation, offset, limit]);

    return (
        <>
            <Paper
                sx={{
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    width: "100%"
                }}
            >
                <Box display="flex" alignItems="center" mb={1} paddingTop={1} paddingLeft={1}>
                    <IconButton size='small' onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant='body2' sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>Volver</Typography>
                </Box>
                <Typography variant='h4' sx={{ mb: 2, textAlign: "center" }}>
                    {t("delegation.table.title")}
                </Typography>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: "100%" }} aria-label="Delegation Table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('delegation.table.name')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadDelegation ? (
                                <TableRow>
                                    <TableCell colSpan={1} align='center'>
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : delegacion.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={1} align='center'>
                                        {t('delegation.table.no_data')}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                delegacion.map((delegacion) => (
                                    <TableRow key={delegacion.id}>
                                        <TableCell align='center'>{delegacion.name}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Pagination count={lastPage} page={currentPage} onChange={handlePageChange} />
            </Box>
        </>
    );

}
export default TableDelegationView;